module.exports = __webpack_public_path__ + "2c79d7d8.png";